const SECURITY_API = 'https://s0blefoi3a.execute-api.us-east-1.amazonaws.com/dev';
const BASE_API = 'https://c3oz4u6496.execute-api.us-east-1.amazonaws.com/v1';
const BASE_VALIDATION = 'https://api.redunica.zeusdes.com';
const VALIDATION_OLD = 'https://obs04mumqk.execute-api.us-east-1.amazonaws.com/v1';

export const environment = {
  production: false,
  env: 'dev',
  ENDPOINTS: {
    SECURITY: SECURITY_API, // encrypt, decrypt
    BASE_RU: BASE_API,
    GET_PROFILES: BASE_API + '/employee-function',
    VALIDATE_EMPLOYEES: BASE_VALIDATION + '/administrador',
    VALIDATION_OLD: VALIDATION_OLD + '/employee-validation'
  },
  AWS_CONFIG: {
    credentials: {
      identityPool: "us-east-1:af38c276-f042-4b69-a0a8-c2e52137fd06", //prod
      region: 'us-east-1',
      structureBucket: 'dev.structure.files',
    },
    bucket: 'dev.zeus.conversaciones',
    bucketTasks: 'dev.zeus.tasks',
    validatorBucket: 'dev.files-validator'
  },
};